import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PaymentAuthListings from '../PaymentAuthListings/PaymentAuthListings';
import Authorise from '../Authorise/Authorise';
import ViewPayment from '../ViewPayment/ViewPayment';
import EditPayment from '../EditPayment/EditPayment';
import { getPage, hasError } from '../../states/page/selectors';
import { goBackPage } from '../../states/page/actions';
import { TIMER_COUNT_LIMIT } from '../../config';

class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.handleBack = this.handleBack.bind(this);
	}

	componentDidMount() {
		this.handleIsListing();
	}

	componentDidUpdate(prevProps) {
		const { hasError, handleRoute, page } = this.props;

		if (hasError) {
			handleRoute('WEB-ERROR');
		}

		if (prevProps.page !== this.props.page) {
			this.handleIsListing();
		}

		switch (page) {
			case 'Accounts':
				handleRoute('WEB-OPEN-MOVEMONEY');
				break;
			case 'PaymentAuthListings':
				break;
			default:
				break;
		}
	}

	handleIsListing() {
		this.props.handleIsListing(this.props.page === 'PaymentAuthListings');
	}

	handleBack() {
		this.props.handleBack();
	}

	render() {
		const { page, handleRefresh, handleRoute, handleEdit, handleEditById } = this.props;

		switch (page) {
			case 'PaymentAuthListings':
				return <PaymentAuthListings handleRefresh={handleRefresh} handleEditById={handleEditById} />;
			case 'Authorise':
				return <Authorise brandId={this.props.brand} handleRoute={handleRoute} />;
			case 'View':
				return <ViewPayment />;
			case 'Edit':
				return <EditPayment handleEdit={handleEdit} />;
			default:
				return <span>{page}</span>;
		}
	}
}

LayoutContainer.defaultProps = {
	handleIsListing: () => {},
};

LayoutContainer.propTypes = {
	page: PropTypes.string.isRequired,
	hasError: PropTypes.bool.isRequired,
	handleBack: PropTypes.func.isRequired,
	handleRoute: PropTypes.func,
	handleRefresh: PropTypes.func,
	handleEdit: PropTypes.func,
	handleIsListing: PropTypes.func,
	handleEditById: PropTypes.func,
};

const mapStateToProps = (state) => ({
	page: getPage(state),
	hasError: hasError(state),
});

const mapDispatchToProps = (dispatch) => ({
	handleBack: () => dispatch(goBackPage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainer);
